import script from "./MonitoringErrorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitoringErrorModal.vue?vue&type=script&setup=true&lang=js"

import "./MonitoringErrorModal.vue?vue&type=style&index=0&id=3c06b7d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c06b7d6"]])

export default __exports__